import { IonicVue } from '@ionic/vue';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from '@/App.vue';

import '@/registerServiceWorker';

import router from '@/router';
import { shouldUseSentry } from '@/util/sentry.js';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';
/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';
/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';
/* FTL Theme */
import '@/theme/variables.css';
import '@/theme/ftl.css';

const pinia = createPinia();

const app = createApp(App)
  .use(pinia)
  .use(IonicVue, {
    innerHTMLTemplatesEnabled: true,
  })
  .use(router);

if (shouldUseSentry()) {
  // Dynamically import Sentry only in production
  void import('@sentry/vue').then((Sentry) => {
    Sentry.init({
      app,
      dsn: 'https://46c312c3d6ad42e2a75146dea868610e@o1111867.ingest.sentry.io/6141123',
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'development',
      integrations: [
        Sentry.browserTracingIntegration({
          router,
        }),
        Sentry.captureConsoleIntegration({
          levels: ['error'],
        }),
      ],
      ignoreErrors: [
        // Asset loading errors (user navigated away, network issues)
        /^Error: Loading CSS chunk .* failed/,
        /^Error: Unable to preload CSS for .*/,
        /^TypeError: Load failed$/,
        /^AbortError/,
        /Fetch is aborted/,
        /Importing a module script failed/,
        /Connection to Indexed Database server lost/,
        // Firebase network errors - SDK handles recovery automatically
        // with offline persistence and retry logic
        /Could not reach Cloud Firestore backend/,
        /Failed to obtain primary lease/,
        /auth\/network-request-failed/,
        /Uncaught Error in snapshot listener/,
        /Detected an update time that is in the future/,
        // Firebase transient/internal errors
        /Installations: Generate Auth Token request failed/,
        /Attempt to delete range from database without an in-progress transaction/,
      ],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.1,
      tracePropagationTargets: ['localhost', 'nextgenftl.com', /^\//],

      denyUrls: [
        // ezoic stuff
        /the\.gatekeeperconsent\.com/i,
        /\/cmbdv2\.js/i,
      ],
    });
  });
}

void router.isReady().then(() => {
  app.mount('#app');
});
